// Positions the "Product added to cart!" popup (.add-to-cart-popup) each time
// theme.js un-hides it: a card under the header on desktop; on mobile a tooltip
// under the header cart icon, or above the dock cart icon when the header is
// hidden. See add-to-cart-toast.css.
(function () {
  var popup = document.querySelector('.add-to-cart-popup');
  if (!popup) return;

  // Lift it out of <main> so no transformed/contained ancestor can turn its
  // position:fixed into "scrolls with the page".
  document.body.appendChild(popup);

  var desktop = window.matchMedia('(min-width: 768px)');
  var shown = false;
  var hideTimer;

  function place() {
    popup.classList.remove('add-to-cart-popup--top', 'add-to-cart-popup--top-mobile', 'add-to-cart-popup--cart-tip', 'add-to-cart-popup--dock-tip');

    var mobileStyle = popup.dataset.mobileStyle;
    if (desktop.matches || mobileStyle === 'top') {
      popup.style.setProperty('--atc-toast-top', headerBottom() + 'px');
      popup.classList.add(desktop.matches ? 'add-to-cart-popup--top' : 'add-to-cart-popup--top-mobile');
      return;
    }

    // Theme settings > Cart: "classic" keeps the original bottom card on mobile.
    if (mobileStyle === 'classic') return;

    // Header showing: tooltip under its cart icon. header-icons renders more
    // than once, so use the copy that's on screen.
    var rect = null;
    document.querySelectorAll('.header-section .cart-drawer-button').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (!rect && r.width && r.height && r.bottom > 4) rect = r;
    });
    if (rect) {
      alignTo(rect);
      popup.style.setProperty('--atc-tip-top', (rect.bottom + 8) + 'px');
      popup.classList.add('add-to-cart-popup--cart-tip');
      return;
    }

    // Header hidden on scroll: tooltip above the dock's cart icon, lifted
    // over anything stacked on the dock (free-gift bar, sticky ATC bar).
    var dockCart = document.querySelector('.mobile-dock .dock__item[aria-controls="CartDrawer"]');
    rect = dockCart && dockCart.getBoundingClientRect();
    // Dock slid off-screen too: keep the original bottom card.
    if (!rect || !rect.height || rect.top >= window.innerHeight - 1) return;

    var top = rect.top;
    document.querySelectorAll('.mobile-dock, .gwp-bottom-message, .product-sticky-form').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.height && r.top < window.innerHeight - 1 && getComputedStyle(el).visibility !== 'hidden') {
        top = Math.min(top, r.top);
      }
    });
    alignTo(rect);
    popup.style.setProperty('--atc-tip-bottom', (window.innerHeight - top + 8) + 'px');
    popup.classList.add('add-to-cart-popup--dock-tip');
  }

  // Where the header's bottom edge rests, or 0 when it's hidden/scrolled away.
  // Uses the theme's header-hidden class and the header's untransformed
  // position, so the answer is right even mid slide-in/out animation.
  function headerBottom() {
    var section = document.querySelector('.header-section');
    var header = section && section.querySelector('.header');
    if (!header) return 0;
    // header-hidden is added on every scroll-down, but it only slides the
    // header away for sticky type "on-scroll-up" or on mobile (mobile-dock.css).
    // Otherwise the header stays put and the toast must stay under it.
    var slidesAway = header.dataset.stickyType === 'on-scroll-up' || !desktop.matches;
    if (slidesAway && section.classList.contains('header-hidden')) return 0;
    // Measure the header, not the section: once scrolled the header is
    // position:fixed, and near the footer the zero-height sticky section
    // scrolls off the top while the header stays on screen. Take off the
    // slide transform's translateY so only where it rests counts.
    var transform = getComputedStyle(header).transform;
    var shift = transform && transform !== 'none' ? new DOMMatrix(transform).m42 : 0;
    return Math.max(0, header.getBoundingClientRect().top - shift + header.offsetHeight);
  }

  // Right-align the tooltip near the icon with its arrow over the icon's centre.
  function alignTo(rect) {
    var viewport = document.documentElement.clientWidth;
    var center = rect.left + rect.width / 2;
    var right = Math.max(8, viewport - center - 28);
    popup.style.setProperty('--atc-tip-right', right + 'px');
    popup.style.setProperty('--atc-tip-arrow-right', (viewport - center - right - 7) + 'px');
  }

  // theme.js shows/hides the popup by toggling .hide from several places;
  // reposition on every hidden -> shown change.
  new MutationObserver(function () {
    var isShown = !popup.classList.contains('hide');
    if (isShown && !shown) {
      wasHeaderHidden = headerHidden();
      place();
      // Auto-hide 2.2s after each show (theme.js's hideCartOpenTost timers
      // aren't reset by a repeat add, so don't rely on them alone).
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () { popup.classList.add('hide'); }, 2200);
    }
    shown = isShown;
  }).observe(popup, { attributes: true, attributeFilter: ['class'] });

  // Re-place only when the header flips between shown and hidden (toast moves
  // to the top of the screen / back under the header). Re-placing on every
  // scroll made it track the header pixel by pixel as it slid away.
  function headerHidden() {
    return headerBottom() <= 1;
  }
  var wasHeaderHidden = false;
  function onHeaderChange() {
    if (!shown) return;
    var hidden = headerHidden();
    if (hidden !== wasHeaderHidden) {
      wasHeaderHidden = hidden;
      place();
    }
  }
  window.addEventListener('scroll', onHeaderChange, { passive: true });
  // The sticky header toggles .header-hidden in its own (throttled) scroll
  // handler, which can land after ours.
  var headerSection = document.querySelector('.header-section');
  if (headerSection) {
    new MutationObserver(onHeaderChange).observe(headerSection, { attributes: true, attributeFilter: ['class'] });
  }

  // Crossing the breakpoint while shown: swap bar <-> tooltip.
  desktop.addEventListener('change', function () {
    if (shown) place();
  });

  popup.querySelector('.add-to-cart-popup__close')?.addEventListener('click', function () {
    popup.classList.add('hide');
  });
})();
